import { Outlet } from 'react-router-dom';
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';

const AppLayout = () => {
  return (
    <>
      <div
        className="noisy-background bg-[#1c1c1f] h-screen overflow-y-auto no-scrollbar relative"
        id="app-layout-main"
      >
        <div className="fixed top-[-136px] left-[-10%] lg:left-[-240px] rotate-[105deg] z-0">
          <div className="glow"></div>
        </div>

        <div className="fixed right-0 lg:right-[-240px] bottom-[-160px] rotate-[-70deg] z-0">
          <div className="glow"></div>
        </div>

        <AppHeader />

        <main className="2xl:px-[104px] px-5 xl:pt-[178px] pt-[114px] pb-[105px] z-10 relative">
          <Outlet />
        </main>

        <AppFooter />
      </div>
    </>
  );
};

export default AppLayout;
